// extracted by mini-css-extract-plugin
export default {"root":"_1rKBO","align-items-center":"-Tbmm","alignItemsCenter":"-Tbmm"};